import { roundAndDropTrailingZeros } from './roundAndDropTrailingZeros';

export function convertBlobSizeToMegaByte(blobSize: number) {
  return blobSize / 1024 / 1024;
}

export function convertBlobSizeToKiloByte(blobSize: number) {
  return blobSize / 1024;
}

export function normalizeFileSize(blobSize: number) {
  const megabyte = convertBlobSizeToMegaByte(blobSize);

  if (megabyte < 1) {
    return `${roundAndDropTrailingZeros(
      convertBlobSizeToKiloByte(blobSize)
    )} KB`;
  }

  return `${roundAndDropTrailingZeros(megabyte)} MB`;
}
